import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
  background: ${({ theme }) => theme.primaryBackgroundColor};

  .ant-layout-sider,
  .ant-layout-header,
  .ant-layout-footer,
  .ant-layout-content {
    background: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;
